import React from 'react';
import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';

const CustomSmallSwitch = styled((props) => <Switch {...props} />)(({ theme }) => ({
  '&.MuiSwitch-root': {
    width: '40px',
    paddingLeft: '0',
    height: '20px',
    padding: '0',
    margin: '4px 0'
  },
  '& .Mui-disabled + .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[300]
  },
  '&  .MuiButtonBase-root': {
    top: '4px',
    left: '-2px',
    paddingBottom: 0,
    paddingTop: 0
  },
  '&  .MuiButtonBase-root.Mui-checked .MuiSwitch-thumb': {
    backgroundColor: 'primary.main',
    transform: 'translateX(0px)'
  },
  '& .MuiSwitch-thumb': {
    width: '12px',
    height: '12px',
    borderRadius: '4px'
  },

  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[200],
    opacity: 1,
    borderRadius: '5px'
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: 'primary',
        opacity: 0.18
      }
    }
  }
}));

export default CustomSmallSwitch;
